import React from 'react';
import CMSPage from 'components/CMSPage';
import styles from './Home.module.scss';


const HomePage = props => (
  <div className={styles.home}>
    <CMSPage {...props} />
  </div>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js